import { Box } from "@mui/material";
import React from "react";

import { CopyButton } from "new-components/buttons/CopyButton";

type CodeBlockProps = {
  content: string;
};

export function CodeBlock({ content }: CodeBlockProps) {
  return (
    <Box className="flex gap-3 items-start w-full">
      <Box
        className="rounded p-1 text-neutral-medium whitespace-pre w-full overflow-auto light-scrollbar font-code"
        sx={{
          border: "1px solid #D9D9D9",
        }}
      >
        {content}
      </Box>

      <CopyButton valueToCopy={content} buttonClassName="p-0" />
    </Box>
  );
}
